// extracted by mini-css-extract-plugin
export default {"dropdown":"search_autocomplete-module___dropdown___fc57ab15","footer":"search_autocomplete-module___footer___c3d5a892"};